var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import Tooltip from "@mui/material/Tooltip";
function isScrollable(el) {
    const style = window.getComputedStyle(el);
    const overflowY = style.overflowY;
    const overflowX = style.overflowX;
    const canScrollY = (overflowY === "auto" ||
        overflowY === "scroll" ||
        overflowY === "overlay") &&
        el.scrollHeight > el.clientHeight;
    const canScrollX = (overflowX === "auto" ||
        overflowX === "scroll" ||
        overflowX === "overlay") &&
        el.scrollWidth > el.clientWidth;
    return canScrollY || canScrollX;
}
function getScrollParents(start) {
    var _a;
    const parents = [];
    let el = (_a = start === null || start === void 0 ? void 0 : start.parentElement) !== null && _a !== void 0 ? _a : null;
    while (el) {
        if (isScrollable(el))
            parents.push(el);
        el = el.parentElement;
    }
    return parents;
}
function mergeRefs(...refs) {
    return (value) => {
        refs.forEach((ref) => {
            if (!ref)
                return;
            if (typeof ref === "function")
                ref(value);
            else
                ref.current = value;
        });
    };
}
export function ScrollCloseTooltip(_a) {
    var { title, disableHoverListener, disableFocusListener, disableTouchListener, onOpen, onClose, children } = _a, rest = __rest(_a, ["title", "disableHoverListener", "disableFocusListener", "disableTouchListener", "onOpen", "onClose", "children"]);
    const hasTitle = title !== undefined &&
        title !== null &&
        !(typeof title === "string" && title.trim().length === 0);
    const anchorRef = React.useRef(null);
    const [open, setOpen] = React.useState(false);
    const handleOpen = React.useCallback((event) => {
        onOpen === null || onOpen === void 0 ? void 0 : onOpen(event);
        setOpen(true);
    }, [onOpen]);
    const handleClose = React.useCallback((event) => {
        onClose === null || onClose === void 0 ? void 0 : onClose(event);
        setOpen(false);
    }, [onClose]);
    React.useEffect(() => {
        if (!open)
            return;
        const anchor = anchorRef.current;
        if (!anchor)
            return;
        const parents = getScrollParents(anchor);
        const opts = { passive: true };
        parents.forEach((p) => p.addEventListener("scroll", handleClose, opts));
        window.addEventListener("scroll", handleClose, opts);
        window.addEventListener("resize", handleClose, opts);
        return () => {
            parents.forEach((p) => p.removeEventListener("scroll", handleClose, opts));
            window.removeEventListener("scroll", handleClose, opts);
            window.removeEventListener("resize", handleClose, opts);
        };
    }, [open, handleClose]);
    if (!hasTitle) {
        return children;
    }
    const childWithRef = React.cloneElement(children, {
        ref: mergeRefs(children.ref, anchorRef),
    }); // React 19: ref is a normal prop; cloneElement prop types do not model it
    return (React.createElement(Tooltip, Object.assign({}, rest, { title: title, open: open, onOpen: handleOpen, onClose: handleClose, disableHoverListener: disableHoverListener, disableFocusListener: disableFocusListener, disableTouchListener: disableTouchListener }), childWithRef));
}
